import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { useMobile } from './MobileContext';
import { LogIn, UserCircle2, Save, Loader2 } from 'lucide-react';
import { MClientHome } from './MClient';

export default function MAccount() {
  const { login, user, logout } = useAuth();
  const navigate = useNavigate();
  const { t, isClient, guest, updateGuest, refresh } = useMobile();
  const isAdmin = user?.role === 'admin';
  const [u, setU] = useState(''); const [p, setP] = useState('');
  const [name, setName] = useState(guest?.name || ''); const [phone, setPhone] = useState(guest?.phone || '');
  const [busy, setBusy] = useState(false);
  const inp = 'w-full h-11 rounded-xl border border-slate-200 px-3 text-sm bg-slate-50';

  const doLogin = async () => {
    if (!u.trim() || !p.trim()) return;
    setBusy(true);
    try {
      const usr = await login(u, p);
      toast.success(t('تم تسجيل الدخول', 'Signed in'));
      if (usr?.role === 'admin') { navigate('/'); return; }
      setTimeout(refresh, 300); navigate('/m/dashboard');
    }
    catch { toast.error(t('اسم المستخدم أو كلمة المرور غير صحيحة', 'Invalid credentials')); }
    setBusy(false);
  };
  const saveGuest = async () => { setBusy(true); try { await updateGuest({ name, phone }); toast.success(t('تم الحفظ', 'Saved')); } catch {} setBusy(false); };

  if (isClient) return <MClientHome />;
  if (isAdmin) return (
    <div className="p-3 space-y-3" data-testid="m-account-admin">
      <div className="rounded-2xl bg-[#0F172A] text-white p-4">
        <p className="text-xs text-white/60">{t('مسجل الدخول كمدير', 'Signed in as admin')}</p>
        <p className="text-base font-bold mt-0.5">{user.username}</p>
        <p className="text-[11px] text-white/60 mt-2 leading-relaxed">{t('لوحة الإدارة (المكالمات، المحادثات، الطلبات) تعمل من هاتفك — اتركها مفتوحة لتصلك المكالمات.', 'The admin dashboard (calls, chats, requests) works on your phone — keep it open to receive calls.')}</p>
        <button onClick={() => navigate('/')} className="w-full mt-3 h-11 rounded-xl bg-[#D4AF37] text-[#0F172A] text-sm font-bold flex items-center justify-center gap-2" data-testid="m-admin-go-dashboard"><LogIn className="w-4 h-4" />{t('الذهاب إلى لوحة الإدارة', 'Open admin dashboard')}</button>
        <button onClick={logout} className="w-full mt-2 h-10 rounded-xl bg-white/10 text-white text-xs font-bold" data-testid="m-admin-logout">{t('تسجيل الخروج', 'Sign out')}</button>
      </div>
    </div>
  );

  return (
    <div className="p-3 space-y-3" data-testid="m-account-guest">
      <div className="rounded-2xl bg-white border border-slate-200 p-4">
        <p className="text-xs font-bold text-slate-500 flex items-center gap-1.5 mb-2"><UserCircle2 className="w-3.5 h-3.5 text-[#D4AF37]" />{t('بياناتك (ضيف)', 'Your details (guest)')}</p>
        <p className="text-[11px] text-slate-400 mb-2">{t('أنت تستخدم التطبيق كضيف — طلباتك محفوظة على هذا الهاتف.', 'You are using the app as a guest — requests are saved on this phone.')}</p>
        <div className="space-y-2">
          <input className={inp} value={name} onChange={e => setName(e.target.value)} placeholder={t('الاسم', 'Name')} data-testid="m-guest-name" />
          <input className={inp} value={phone} onChange={e => setPhone(e.target.value)} placeholder={t('رقم الهاتف', 'Phone')} dir="ltr" type="tel" data-testid="m-guest-phone" />
          <button onClick={saveGuest} disabled={busy} className="w-full h-10 rounded-xl bg-slate-800 text-white text-sm font-bold flex items-center justify-center gap-2" data-testid="m-guest-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}{t('حفظ', 'Save')}</button>
        </div>
      </div>
      <div className="rounded-2xl bg-white border border-slate-200 p-4">
        <p className="text-xs font-bold text-slate-500 flex items-center gap-1.5 mb-1"><LogIn className="w-3.5 h-3.5 text-[#D4AF37]" />{t('صاحب منشأة؟ سجّل دخولك', 'Company owner? Sign in')}</p>
        <p className="text-[11px] text-slate-400 mb-2">{t('استخدم اسم المستخدم وكلمة المرور التي زوّدك بها مكتب AZIZI.CO', 'Use the username and password provided by AZIZI.CO')}</p>
        <div className="space-y-2">
          <input className={inp} value={u} onChange={e => setU(e.target.value)} placeholder={t('اسم المستخدم', 'Username')} autoComplete="username" data-testid="m-login-username" />
          <input className={inp} type="password" value={p} onChange={e => setP(e.target.value)} placeholder={t('كلمة المرور', 'Password')} autoComplete="current-password" data-testid="m-login-password" />
          <button onClick={doLogin} disabled={busy} className="w-full h-11 rounded-xl bg-[#D4AF37] text-[#0F172A] text-sm font-bold flex items-center justify-center gap-2" data-testid="m-login-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}{t('تسجيل الدخول', 'Sign in')}</button>
        </div>
      </div>
    </div>
  );
}
